/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppEmbeddedSignupActivatePathParams,
	WhatsAppEmbeddedSignupActivateResponse,
} from '../types/WhatsAppEmbeddedSignupActivate'

/**
 * POST /organisations/:organisationId/whatsapp-account/activate
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::activate
 */
export async function whatsAppEmbeddedSignupActivate(
	organisationId: WhatsAppEmbeddedSignupActivatePathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppEmbeddedSignupActivateResponse>> {
	return axiosInstance.post(`/organisations/${organisationId}/whatsapp-account/activate`, undefined, config)
}
